import 'twin.macro';

import { type Location } from '@cheqroom/api';
import { getIcon } from '@cheqroom/icons';
import { Icon, Stack, Text } from '@cheqroom/ui';
import { ReactNode } from 'react';

/**
 * Creates tooltip content showing the full location path with icons
 */
export const createLocationPathTooltip = (locations: Location[] | undefined): ReactNode => {
	if (!locations || locations.length === 0) {
		return undefined;
	}

	return (
		<Stack vertical>
			{locations.map((loc) => {
				return (
					<Stack key={loc._id} spacing="extraTight" align="center">
						<Icon color="white" source={getIcon(loc.icon, 'Marker')} size="small" />
						<Text tw="text-white" size="small">
							{loc.name}
						</Text>
					</Stack>
				);
			})}
		</Stack>
	);
};
